import { ModalDrawer } from '@/components/ui/modal-drawer';
import { InvitationModal } from './InvitationModal';

interface InvitationModalDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  familyId: string;
  linkedPersonId?: string;
  onSuccess?: () => void;
}

export function InvitationModalDrawer({ 
  open, 
  onOpenChange, 
  familyId, 
  linkedPersonId, 
  onSuccess 
}: InvitationModalDrawerProps) {
  return (
    <ModalDrawer
      open={open}
      onOpenChange={onOpenChange}
      title="Inviter un membre de la famille"
      description="Envoyez une invitation pour rejoindre votre espace familial"
    >
      <InvitationModal
        familyId={familyId}
        linkedPersonId={linkedPersonId}
        onClose={() => onOpenChange(false)}
        onSuccess={() => {
          onSuccess?.();
          onOpenChange(false);
        }}
      />
    </ModalDrawer>
  );
}